module.exports = "/fonts/themify.ttf?e23a7dcaefbde4e74e263247aa42ecd7";